export class PackingMaterialPricesRequest{
    id:number
    productId:number
    // category:FgPriceListCategoryEnum
    packStyleId:number
    price:number
    createdUser:string
    updatedUser:string
    packStyle:string
    product:string
    isActive:boolean
    versionFlag:number
    updatedAt?:Date
    constructor(
        id:number,
        productId:number,
        // category:FgPriceListCategoryEnum,
        packStyleId:number,
        price:number,
        createdUser:string,
        updatedUser:string,
        packStyle:string,
        product:string,
        isActive:boolean,
    versionFlag:number,
    updatedAt?:Date

    ){
        this.id=id
        this.productId=productId
        // this.category=category
        this.packStyleId=packStyleId
        this.price=price
        this.createdUser=createdUser
        this.updatedUser=updatedUser
        this.packStyle=packStyle
        this.product=product
        this.versionFlag = versionFlag
        this.isActive = isActive
        this.updatedAt=updatedAt
    }
}